export default "/static/common/load-img.png"